import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: "Crowd",
          scrollbars: false,
        },
      },
      styles: {
        justifyContent: "flex-start",
        fontSize: "12px",
        fontWeight: 700,
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "original",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/original-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "62",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/62-lightweight-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "58",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/58-lightweight-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "54",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/54-lightweight-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "50",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/50-lightweight-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "46",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/46-lightweight-crowd.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "secondary",
          text: "42",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/42-lightweight-crowd.wav`,
        },
      },
    },
  },
];

export default components;
